import { Backdrop, CircularProgress } from '@mui/material';
import { ReactNode, useState } from 'react';

interface LoadingProps {
  children: ReactNode;
}

/**
 * ローディング状態に応じてイベント発火や表示コンポーネントを切り替えるHook。
 * @returns
 */
export const useLoading = () => {
  // ローディング状態(true:ローディング中)
  const [loading, setLoading] = useState(false);

  /**
   * ローディング状態に応じてイベントを発火する。
   * @param successEvent ローディング成功時のイベント
   * @param failedEvent ローディング失敗時のイベント
   * @param finallyEvent ローディング成功/失敗に関わらず、処理の最後に実行するイベント
   */
  const loadingEvent = async (successEvent: () => void, failedEvent?: () => void, finallyEvent?: () => void) => {
    setLoading(true);
    try {
      await successEvent();
    } catch (e) {
      failedEvent && (await failedEvent());
    } finally {
      finallyEvent && (await finallyEvent());
      await setLoading(false);
    }
    return;
  };

  /**
   * ローディング状態に応じて表示するコンポーネント。
   * @param component ローディング完了後に表示するコンポーネント
   * @param loadingComponent ローディング中に表示するコンポーネント
   */
  const Loading = ({ children }: LoadingProps) => {
    return (
      <>
        {children}
        <Backdrop
          sx={{ color: '#fff', backgroundColor: '#0003', zIndex: (theme) => theme.zIndex.modal + 1 }}
          open={loading}
        >
          <CircularProgress color={'inherit'} />
        </Backdrop>
      </>
    );
  };

  return { loadingEvent, Loading };
};
